export default __webpack_public_path__ + "locales/ja-JP/Ldap.json?hash=56d892316639ef7c5a4d0cf611671fd9";